module.exports = __webpack_public_path__ + "static/media/virtual-reality-coding.4ccfd789.png";